const integer = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;
const random_element = (arr) => arr[Math.floor(Math.random() * arr.length)];

const casual = {
  integer,
  random_element,
  define: (name, factory) => {
    Object.defineProperty(casual, name, { get: factory, configurable: true });
  },
};

casual.define('partner', () => ({
  id: casual.integer(1, 1000),
  name: casual.random_element([
    'Notre Temps',
    'Femme actuelle',
    'Horoscope',
    'CESU',
  ]),
  partnerNumber: `P0000${casual.integer(10, 99)}`,
}));

casual.define('thematic', () => ({
  id: casual.integer(1, 1000),
  name: casual.random_element([
    'Économie',
    'Santé',
    'Sport',
    'Vie pratique et quotidienne',
    '',
  ]),
  partnerNumber: `P0000${casual.integer(10, 99)}`,
}));

export default casual;
